import React, { useState, useEffect } from 'react';
import { MotifMenu, MotifMenuItem, MotifButton, MotifToast } from "@ey-xd/motif-react";
import ClientEngagementUploader from './ClientEngagementUploader';

import './partnerFileUpload.scss';



export const AddFiles = ({ show, onClose, items, rowData,triggerEngagementUpdate, isToastVisible, setIsToastVisible, failedUploads, setFailedUploads, handleRemoveFile, openFailedUploadBadge, uploadPercentage, setUploadPercentage, fileStatus, failedUploadData, setFailedUploadLoadData, isFailedUploadLoadData, engagementPauseStatus, initiateAutoProcess, setFailedUploadData, isAddFilesOpen, setAlertMessage, setOpenAlertDialog }) => {
  const [activeTab, setActiveTab] = useState('clientEngagement'); // State for active tab
  const [fileCount, setFileCount] = useState(0);
  const [EyOwnedfileCount, setEyOwnedFileCount] = useState(0);
  const [allProtectedFilesCount, setAllProtectedFilesCount] = useState(false);
  const [clientDataToast, setClientDataToast] = useState(true);

  const handleUploaderClose = () => {
    onClose(); // Call the onClose prop function to close the AddFiles component
  };
  useEffect(() => {
    if (rowData?.clientData) {
      setActiveTab('clientEngagement');
    } else {
      setActiveTab('eyOwned');
    }
  }, [rowData?.eyOwnedData, rowData?.clientData]);
  useEffect(() => {
    setIsToastVisible(true);
  }, [rowData?.engagementId]);

  useEffect(() => {
    if(isAddFilesOpen === false || isAddFilesOpen === null){
      setClientDataToast(true);
    }
  }, [isAddFilesOpen]);

  return (

    <MotifMenu show={show} onClose={onClose} className="motif-menu-container">


      {
        
        (
          // logic when condition is false
          <>
            <div className="motif-menu-view-files-container">
              <MotifMenuItem className="motif-menu-view-files" disabled>
                {openFailedUploadBadge ? (
                  <>
                    <strong>Failed Upload</strong>
                  </>
                ) : (
                  <strong>Add Files</strong>
                )}
                {/* <strong>Add Files </strong> */}
                <div className="engagement-id addFilesMenu">
                  {rowData?.engagementId} | {rowData?.engagementName}
                </div>

              </MotifMenuItem>
            </div>
            <div className="tab-buttons">
              {rowData?.clientData && (
                <MotifButton
                  className={activeTab === 'clientEngagement' ? 'selected' : ''} // Add selected class
                  variant={activeTab === 'clientEngagement' ? 'primary' : 'secondary'}
                  onClick={() => {
                    setActiveTab('clientEngagement');
                    setEyOwnedFileCount(0); // Reset EY Owned file count to 0
                  }}
                >
                  Client Data & EY Owned Data  {!openFailedUploadBadge && !allProtectedFilesCount ? (<span className="no-of-files">{fileCount}</span>) : null}
                </MotifButton>
              )}

              {!rowData?.clientData && (
                <>
                  <MotifButton
                    className={activeTab === 'eyOwned' ? 'selected' : ''} // Add selected class
                    variant={activeTab === 'eyOwned' ? 'primary' : 'secondary'}
                    onClick={() => {
                      setActiveTab('eyOwned');
                      setFileCount(0); // Reset Client Data file count to 0
                    }}
                  >
                    EY Owned Data <span className="no-of-files">{fileCount}</span>
                  </MotifButton>
                  {isToastVisible && clientDataToast && ( // Render toast only if visible
                    <MotifToast
                      variant="error"
                      className="eyOwned-toast-container"
                      onClick={() => setIsToastVisible(false)} // Close toast on click
                    >
                      <div className="result">
                        <p className="custom-warning-message">
                          Client data must not be entered.
                        </p>
                        <p className="custom-info-message">
                          If you have any questions please reach out to <strong>DBS@parthenon.ey.com</strong>
                        </p>
                      </div>
                    </MotifToast>
                  )}
                </>
              )}
            </div>
            <ClientEngagementUploader
              setFailedUploads={setFailedUploads}
              failedUploads={failedUploads}
              setFailedUploadData={setFailedUploadData}
              failedUploadData={failedUploadData}
              isFailedUploadLoadData={isFailedUploadLoadData}
              onClose={handleUploaderClose}
              rowData={rowData}
              setFileCount={setFileCount}
              totalFileCount={fileCount}
              triggerEngagementUpdate={triggerEngagementUpdate}
              isClientEngagement={activeTab === 'clientEngagement'}
              handleRemoveFile={handleRemoveFile}
              openFailedUploadBadge={openFailedUploadBadge}
              uploadPercentage={uploadPercentage}
              setUploadPercentage={setUploadPercentage}
              fileStatus={fileStatus}
              setFailedUploadLoadData={setFailedUploadLoadData}
              engagementPauseStatus={engagementPauseStatus}
              initiateAutoProcess={initiateAutoProcess}
              setAllProtectedFilesCount={setAllProtectedFilesCount}
              onClientDataChange={(data) => { setClientDataToast(data); }}
              setAlertMessage={setAlertMessage}
              setOpenAlertDialog={setOpenAlertDialog}            
            />
            <div className="close-button-container">
            </div>
          </>
        )


      }
    </MotifMenu>
  );
};